class CartDrawer extends HTMLElement {
  constructor() {
    super();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-items',
        section: 'cart-items',
        selector: '.js-cart-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'cart-footer',
        section: 'cart-footer',
        selector: '.js-cart-footer-contents'
      },
      {
        id: 'cart-drawer-icon-bubble',
        section: 'cart-drawer-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

document.addEventListener('click', async function (event) {
  const button = event.target.closest('#CartDrawerUpsellAdd');
  if (!button) return;

  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();

  const root = document.getElementById('CartDrawerUpsell-DeepFoil');
  if (!root) return false;

  const variantSelect = root.querySelector('#CartDrawerUpsellVariant');
  const feedback = root.querySelector('#CartDrawerUpsellFeedback');

  if (!variantSelect) return false;

  const variantId = parseInt(variantSelect.value, 10);
  const quantity = 1;

  const cartDrawer = document.querySelector('cart-drawer');
  const cartMain = document.querySelector('cart-main');
  const cartLocation = cartDrawer || cartMain;

  if (!cartLocation || typeof cartLocation.getSectionsToRender !== 'function') {
    console.error('Upsell error: impossible de trouver cart-drawer ou cart-main');
    return false;
  }

  button.disabled = true;
  button.textContent = 'Ajout...';

  if (feedback) {
    feedback.hidden = true;
    feedback.textContent = '';
  }

  try {
    const body = JSON.stringify({
      items: [
        {
          id: variantId,
          quantity: quantity
        }
      ],
      sections: cartLocation.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    const response = await fetch('/cart/add.js', {
      ...fetchConfig(),
      body
    });

    const parsedState = await response.json();

    if (!response.ok || parsedState.status) {
      throw new Error(parsedState.description || 'Erreur lors de l’ajout au panier');
    }

    cartLocation.getSectionsToRender().forEach((section) => {
      const container = document.getElementById(section.id);
      if (!container) return;

      const elementToReplace =
        container.querySelector(section.selector) || container;

      const html = parsedState.sections[section.section];
      if (!html) return;

      const newContent = new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(section.selector);

      if (newContent) {
        elementToReplace.innerHTML = newContent.innerHTML;
      }
    });

    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'cart-upsell',
        cartData: parsedState,
        variantId: variantId
      });
    }
  } catch (error) {
    console.error('Upsell error:', error);

    if (feedback) {
      feedback.hidden = false;
      feedback.textContent = error.message || 'Impossible d’ajouter le produit.';
    }
  } finally {
    button.disabled = false;
    button.textContent = 'Ajouter au panier';
  }

  return false;
}, true);